import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ModalService} from '../../modal';
import {OverlayModule} from '../../overlay';
import {L10nModule} from '../../translate';
import {MultiselectDropdownMenuComponent} from './multiselect-dropdown-menu.component';

@NgModule({
    imports: [
        CommonModule,
        L10nModule,
        OverlayModule
    ],
    declarations: [
        MultiselectDropdownMenuComponent
    ],
    providers: [
        ModalService
    ]
})
export class MultiselectDropdownMenuModule {}
